import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {FeatureFlagEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {InstanceComplianceStandardsForm} from 'src/app/instance-compliance-standards/InstanceComplianceStandardsForm';
import {ComplianceStandardsBrowserShell} from 'src/app/compliance-standards/ComplianceStandardsBrowserShell';
import {complianceTreeRootId} from 'src/app/compliance-standards/complianceStandardTreeState';
import {InstanceComplianceStandardDocumentTitle} from 'src/app/instance-compliance-standards/instanceComplianceStandardsHelper';

const CreateInstanceComplianceStandardPage = () => {
  useSetDocumentTitle(InstanceComplianceStandardDocumentTitle);

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Compliance}>
      <ComplianceStandardsBrowserShell
        variant="regulatory"
        selectedId={complianceTreeRootId}>
        <InstanceComplianceStandardsForm mode="create" />
      </ComplianceStandardsBrowserShell>
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.InstanceComplianceStandardsCreate(':standardId'),
  element: <CreateInstanceComplianceStandardPage />,
  module: ModuleEnum.Compliance,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});

export default CreateInstanceComplianceStandardPage;
